export default {
    title: 'Signup',
    username: 'Username',
    describeYourself: 'Describe yourself',
    describeOthers: 'Describe others',
    uploadImages: 'Upload images',
    presentYourself: 'Present yourself with your photos',
    pickFile: 'Pick file',
    contactWaysTitle: 'Please choose your contact ways'
}
